export default {
  background: '#fffff7',
  accent: 'hsl(14, 100%, 50%)',
  color: 'hsl(0, 10%, 10%)',
  complementary: 'hsl(216, 100%, 50%)',
  clearcolor: '#fffff7',
  fontbody: '"Open Sans", Georgia, Serif',
  fonttitle:  '"Monument Extended", Helvetica, Arial, sans-serif',
  fonttitle2: '"Montserrat", Helvetica, Arial, sans-serif',
  fonttitle3: '"Libre Baskerville", Georgia, serif',
  fonttitlesize: '4rem',
  fontsize: '1.1875rem',
  lineheight: '1.8125rem',
  normalWidth: '680px',
  maxWidth: '1200px',
  overWidth: '1440px',
  button: {
    backgroundColor: '#a21521',
    color: '#fffff7',
    borderRadius: '4px',
    padding: '1rem 2rem'
  }
};